import "./ScoreCardRow.css";
import ScoreCardButton from "./ScoreCardButton";
import ScoreCardLockButton from "./ScoreCardLockButton";
import classnames from "classnames";

interface ScoreCardRowProps {
  color: string;
  data: number[];
  isLocked: boolean;
  size: string;
  playable: boolean;
}

function ScoreCardRow({
  color,
  data,
  isLocked,
  size,
  playable,
}: ScoreCardRowProps) {
  const buttons: JSX.Element[] = [];

  const isDisabled = (i: number): boolean => {
    if (!playable) {
      return true;
    }

    if (data.includes(i)) {
      return true;
    }

    if (color === "red" || color === "yellow") {
      if (i <= Math.max(...data)) {
        return true;
      } else if (i === 12 && data.length < 5) {
        return true;
      } else {
        return false;
      }
    } else if (color === "blue" || color == "green") {
      if (i >= Math.min(...data)) {
        return true;
      } else if (i === 2 && data.length < 5) {
        return true;
      } else {
        return false;
      }
    }

    return false;
  };

  const addButton = (i: number) => {
    const numberAlreadyUsed = data.includes(i);
    const disabled = isDisabled(i);

    buttons.push(
      <ScoreCardButton
        key={i}
        color={color}
        number={i}
        disabled={disabled}
        locked={isLocked}
        marked={numberAlreadyUsed}
        size={size}
      />,
    );
  };
  let lockMarked = false;
  if (color === "red" || color === "yellow") {
    for (let i = 2; i < 13; i++) {
      addButton(i);
    }
    if (data.includes(12)) {
      lockMarked = true;
    }
  } else {
    for (let i = 12; i > 1; i--) {
      addButton(i);
    }
    if (data.includes(2)) {
      lockMarked = true;
    }
  }

  const klasses = classnames("scoreCardRow", color, size);
  return (
    <div className={klasses}>
      {buttons.map((button) => {
        return button;
      })}
      <ScoreCardLockButton color={color} marked={lockMarked} size={size} />
    </div>
  );
}

export default ScoreCardRow;
